import React, { useEffect, useState } from "react";
import DefaultRoutes from "./routes/routes";
import { useDispatch, useSelector } from "react-redux";
import html2canvas from "html2canvas";
import { useParams, useSearchParams } from "react-router-dom";
import { config } from "./redux/slices/auth/configSlice";
import { toast } from "react-toastify";
import Loader from "./components/common/loader";
import { setUserLocation } from "./redux/slices/auth/locationSlice";
import eventEmitter from "./events/eventEmitter";
import {
  LocationAllowModal,
  LocationBlockedModal,
  InactiveModal,
} from "./components";
import PreloadImages from "./components/common/preloadImages";
import {
  LoginSignUpStaticImages,
  SidebarStaticIcons,
  staticImages,
} from "./helper/utils";
import useDeviceTracker from "./helper/useDeviceTracker";
import { use } from "react";

function App() {
  useDeviceTracker();
  const deviceInfo = useSelector((state) => state?.device?.deviceInfo);
  console.log(deviceInfo, "deviceInfo----------");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [ShowLocationBloackedModal, setShowLocationBloackedModal] =
    useState(false);
  const [showDomainInactiveModal, setShowDomainInactiveModal] = useState(false);

  const [locationMessage, setLocationMessage] = useState(""); // for 403 message

  const fetchReverseGeocode = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
      );
      const data = await response.json();
      const { address } = data;
      console.log(34, data);
      console.log("Location fetched:", address);

      // Dispatch to store
      dispatch(setUserLocation({ latitude: lat, longitude: lon, ...address }));
    } catch (error) {
      console.error("Reverse geocoding failed", error);
    }
  };

  const handleDownload = () => {
    const element = document.getElementById("captureDiv");

    html2canvas(element).then((canvas) => {
      const image = canvas.toDataURL("image/jpg");

      const link = document.createElement("a");
      link.href = image;
      link.download = "my-div.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  // const getUserLocation = () => {
  //   navigator.geolocation.getCurrentPosition(
  //     (position) => {
  //       const { latitude, longitude } = position.coords;
  //       fetchReverseGeocode(latitude, longitude);
  //     },
  //     (error) => {
  //       console.warn("Location access denied");
  //       // setShowLocationModal(true); // show modal if permission denied
  //     }
  //   );
  // };

  const getUserLocation = () => {
    console.log(75);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        fetchReverseGeocode(latitude, longitude);
        setShowLocationModal(false); // Location granted → close modal
      },
      (error) => {
        console.warn("Location access denied or failed", error);

        if (error.code === error.PERMISSION_DENIED) {
          // User denied location again
          toast.error("Location permission is required to continue.");
          setShowLocationModal(true); // Keep modal open
        } else {
          // Other geolocation errors
          toast.error("Unable to fetch location. Please try again.");
          setShowLocationModal(true);
        }
      }
    );
  };

  const checkGeolocationPermission = async () => {
    if (!navigator.permissions || !navigator.geolocation) {
      console.warn("Geolocation not supported");
      return;
    }

    const result = await navigator.permissions.query({ name: "geolocation" });

    if (result.state === "granted") {
      getUserLocation();
    } else if (result.state === "prompt") {
      getUserLocation(); // will ask user
    } else if (result.state === "denied") {
      // setShowLocationModal(true);
    }

    // Listen to changes (e.g. user enables location in browser settings)
    result.onchange = () => {
      if (result.state === "granted") {
        setShowLocationModal(false);
        getUserLocation();
      }
    };
  };

  // useEffect(() => {
  //   checkGeolocationPermission();
  // }, []);

  const domain = process.env.REACT_APP_FRONT_URL;
  console.log(domain, "domain");

  useEffect(() => {
    const autoConfig = async () => {
      const vpnToken = localStorage.getItem("vpnToken");
      const payload = { domain, vpnToken };

      try {
        const res = await dispatch(config(payload)).unwrap();
        console.log("config vpn", payload, res);
        if (res.success) {
          // toast.success(res.message);
          // navigate("/home-screen");
        }
        if (res.status == 404) {
          setShowDomainInactiveModal(true);
        }
      } catch (error) {
        toast.error(error.message);
        console.error("Config Failed:", error);
      }

      setIsLoading(false);
    };

    autoConfig();
  }, []);

  useEffect(() => {
    // const handleMissingLocation = () => {
    //   setShowLocationModal(true);
    //   // setLocationMessage("Location access is required to continue.");
    // };

    const handleLocationBlocked = (msg) => {
      setLocationMessage(msg); // set message from backend
      setShowLocationBloackedModal(true); // open modal
    };

    // eventEmitter.on("missingLocation", handleMissingLocation);
    eventEmitter.on("locationBlocked", handleLocationBlocked);

    return () => {
      // eventEmitter.off("missingLocation", handleMissingLocation);
      eventEmitter.off("locationBlocked", handleLocationBlocked);
    };
  }, []);

  useEffect(() => {
    const handler = () => setShowLocationModal(true);
    eventEmitter.on("missingLocation", handler);
    console.log("missingLocation");

    return () => {
      eventEmitter.off("missingLocation", handler);
    };
  }, []);

  return (
    <>
      {/* <div>
        <div
          id="captureDiv"
          className="text-center"
          style={{ width: 709, height: 1063, padding: 5, border: "1px solid #000" }}
        >
          <h2>This div will be captured</h2>
          <p>You can style it however you like.</p>
        </div>
        <button onClick={handleDownload}>Download as Image</button>
      </div> */}
      <DefaultRoutes />
      {isLoading && <Loader />}

      {showLocationModal && (
        <LocationAllowModal
          open={showLocationModal}
          setOpen={setShowLocationModal}
          onRetry={() => {
            getUserLocation();
          }}
        />
      )}
      {ShowLocationBloackedModal && (
        <LocationBlockedModal
          open={ShowLocationBloackedModal}
          setOpen={setShowLocationBloackedModal}
          message={locationMessage}
          onClick={() => {
            setShowLocationBloackedModal(false);
            window.location.href = "/";
          }}
        />
      )}
      {showDomainInactiveModal && (
        <InactiveModal
          open={showDomainInactiveModal}
          setOpen={setShowDomainInactiveModal}
          onClick={() => {
            window.location.reload("/");
          }}
        />
      )}
    </>
  );
}

export default App;
